<script lang="ts" setup>
import { Icon } from '@iconify/vue2'
import { onMounted, ref } from 'vue'
const props = defineProps({
	label: String,
	startOpened: {
		type: Boolean,
		default: false,
	},
})

const opened = ref(false)

onMounted(() => {
	opened.value = props.startOpened
})
</script>

<template>
	<div>
		<div
			class="flex justify-between items-center cursor-pointer"
			@click="opened = !opened"
		>
			<label class="text-[#464947] font-bold cursor-pointer">{{ label }}</label>
			<Icon
				icon="ph:caret-down-bold"
				:rotate="opened ? 2 : 0"
			/>
		</div>
		<div
			v-show="opened"
			class="pt-2"
		>
			<slot />
		</div>
		<hr class="border-[#67889E] mt-3" />
	</div>
</template>

<style scoped></style>
